var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#7F7F7F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9544 9.44857L7.86393 11.822C7.51679 12.0232 7.07129 11.7796 7.07129 11.3739V6.62707C7.07129 6.22207 7.51615 5.97779 7.86393 6.17965L11.9544 8.55307C12.0334 8.59815 12.099 8.66332 12.1447 8.74195C12.1904 8.82059 12.2144 8.9099 12.2144 9.00082C12.2144 9.09175 12.1904 9.18106 12.1447 9.2597C12.099 9.33833 12.0334 9.40349 11.9544 9.44857V9.44857Z",
    fill: "#FFCA3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayIcon);
export default __webpack_public_path__ + "static/media/video-play-icon.ac5d8869d9c163a1a0a4df75061fa54f.svg";
export { ForwardRef as ReactComponent };